module.exports = __webpack_public_path__ + "media/winter_2023_sweepstakes/twitter-social-icon-9b1d3e68.svg";